import { functions } from 'helpers';
import { ruleRunner } from 'validations/ruleRunner';
import { maximum, minimun, required, ruleIfInArray } from 'validations/rules';

// adicionado pois na criação a prop inicia como number
const CAIXA_PACOTE = 1,
  ROLO_PRISMA = 2;

const CAIXA_PACOTE_EDIT = '1',
  ROLO_PRISMA_EDIT = '2';

const requiredPositiveWeight = (value: unknown) => {
  if (value === undefined || value === null || value === '') {
    return () => 'Informe o peso do produto';
  }

  const numeric = Number(functions.clearMoneyMask(value as string | number));
  return !Number.isNaN(numeric) && numeric > 0 ? null : () => 'Informe o peso do produto';
};

const Validations = [
  ruleRunner('zip_code', 'CEP de origem', required),
  ruleRunner(
    'weight',
    'peso',
    requiredPositiveWeight,
    ruleIfInArray('deliveryType', [40010], maximum(30)),
    ruleIfInArray('deliveryType', [40215], maximum(10)),
    ruleIfInArray('deliveryType', [41106], maximum(30))
  ),
  ruleRunner(
    'height',
    'altura',
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], required),
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], minimun(1)),
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], maximum(100))
  ),
  ruleRunner(
    'width',
    'largura',
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], required),
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], minimun(8)),
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], maximum(100))
  ),
  ruleRunner(
    'length',
    'comprimento',
    required,
    ruleIfInArray('format', [CAIXA_PACOTE, CAIXA_PACOTE_EDIT], minimun(13)),
    ruleIfInArray('format', [ROLO_PRISMA, ROLO_PRISMA_EDIT], minimun(18)),
    maximum(100)
  ),
  ruleRunner(
    'diameter',
    'diâmetro',
    ruleIfInArray('format', [ROLO_PRISMA, ROLO_PRISMA_EDIT], required),
    ruleIfInArray('format', [ROLO_PRISMA, ROLO_PRISMA_EDIT], minimun(5)),
    ruleIfInArray('format', [ROLO_PRISMA, ROLO_PRISMA_EDIT], maximum(91))
  ),
  ruleRunner('delivery_options', 'tipo de entrega', (options: unknown) =>
    Array.isArray(options) && options.length >= 1
      ? null
      : () => 'Selecione ao menos uma opção de entrega: PAC, SEDEX ou SEDEX 10'
  )
];

export default Validations;
